export const arrayToOptions = (array: string[] | undefined | null, includeBlank = true, blankLabel = "") => {
  const options = array ? array.map((item) => ({ value: item, label: item })) : [];
  if (includeBlank) {
    return [{ value: "", label: blankLabel }, ...options];
  } else {
    return options;
  }
};
